import styled from "@emotion/styled";

export const LimitedWidth = styled.div`
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
`;
